import { ProcessStep, QuoteRequestLine } from "../types";
import { computeCyleTime } from "./computeCycleTime";

export const computeMachineTime = ({
  processStep,
  totalQuantity,
  reworkRatio,
}: {
  processStep: ProcessStep;
  totalQuantity: number;
  reworkRatio: QuoteRequestLine["reworkRatio"];
}): number => {
  const machinePreparationTime = processStep.machinePreparationTime ?? 0;
  const machineTime =
    computeCyleTime({
      processStep,
      totalQuantity,
      reworkRatio,
    }) + machinePreparationTime;

  return machineTime;
};
